import { RefObject, useState } from 'react';
import useArrowKeys from '../useArrowKays/useArrowKeys';

const useArrowNavigation = (ref: RefObject<any>, totalResults: number) => {
  const [currentItemIndex, setCurrentItemIndex] = useState<number | null>(null);
  const focusableChildren: HTMLCollection | undefined = ref?.current
    ? ref?.current.querySelectorAll('button, [href], input, select, textarea')
    : null;

  const handleArrowNavigation = (key: string) => {
    if (currentItemIndex || currentItemIndex === 0) {
      if (focusableChildren) {
        if (key === 'ArrowRight' || key === 'ArrowDown') {
          if (currentItemIndex + 1 < totalResults) {
            (focusableChildren as HTMLCollectionOf<HTMLElement>)[
              currentItemIndex + 1
            ].focus();
            setCurrentItemIndex(currentItemIndex + 1);
          } else {
            (focusableChildren as HTMLCollectionOf<HTMLElement>)[0].focus();
            setCurrentItemIndex(0);
          }
        }

        if (key === 'ArrowLeft' || key === 'ArrowUp') {
          if (currentItemIndex === 0) {
            (focusableChildren as HTMLCollectionOf<HTMLElement>)[
              totalResults - 1
            ].focus();
            setCurrentItemIndex(totalResults - 1);
          } else {
            (focusableChildren as HTMLCollectionOf<HTMLElement>)[
              currentItemIndex - 1
            ].focus();
            setCurrentItemIndex(currentItemIndex - 1);
          }
        }
      }
    }
  };

  useArrowKeys(ref, e => {
    // NOTE: If you're using this hook twice in the same component with similar refs, make sure to use
    // an extra className to differentiate between them
    // i.e. "search-results" -> "search-results cast" "search-results titles"
    const { parentNode } = e.target;
    const isChild =
      parentNode?.parentNode?.classList?.contains(ref.current.classList) || // if nested in <li>
      parentNode.classList.contains(ref.current.classList) ||
      parentNode.isSameNode(ref.current);

    if (isChild) {
      e.preventDefault();
      handleArrowNavigation(e.key);
    }
  });

  return {
    currentItemIndex,
    setCurrentItemIndex,
  };
};

export default useArrowNavigation;
